export interface PageSkeletonProps {
  /** What a screen reader hears while the page is on its way. */
  label?: string;
  /** Body placeholder lines under the heading bar. */
  lines?: number;
}

export function PageSkeleton({ label = 'Loading…', lines = 4 }: PageSkeletonProps) {
  return (
    <div className="page-skeleton" role="status" aria-live="polite" aria-busy="true">
      <span className="page-skeleton-label">{label}</span>
      <div className="page-skeleton-bar page-skeleton-eyebrow" aria-hidden="true" />
      <div className="page-skeleton-bar page-skeleton-heading" aria-hidden="true" />
      {Array.from({ length: lines }, (_, index) => (
        <div className="page-skeleton-bar page-skeleton-line" key={index} aria-hidden="true" />
      ))}
    </div>
  );
}
